<template>
  <div class="content" id="app">
    <router-view></router-view>
    <!--     <div style="position: absolute; top: 0; z-index: 1000; opacity: 0.8; background: gray">
      <router-link to="/" style="color: white">Перейти к Main</router-link>
      <br />
      <router-link to="/login" style="color: white">Перейти к Login</router-link>
    </div>-->
  </div>
</template>

<script>
export default {
  name: "app",
  mounted() {
    window.addEventListener("keydown", this.stopWindowZoom, { passive: false });
    window.addEventListener("mousewheel", this.stopWindowZoom, {
      passive: false,
    });
  },
  components: {},
  methods: {
    stopWindowZoom(event) {
      if (
        (event.ctrlKey || event.metaKey) &&
        (event.which == "61" ||
          event.which == "107" ||
          event.which == "173" ||
          event.which == "109" ||
          event.which == "187" ||
          event.which == "189" ||
          event.type === "mousewheel")
      ) {
        // 107 Num Key  +
        // 109 Num Key  -
        // 173 Min Key  hyphen/underscor Hey
        // 61 Plus key  +/= key
        event.preventDefault();
      }
    },
  },
};
</script>

<style lang="scss">
@font-face {
  font-family: "Ubuntu";
  src: url("./assets/fonts/GRILLEDCHEESE-BTN-TOASTED.TTF") format("truetype-variations");
}

@font-face {
  font-family: "Grilled Cheese BTN";
  src: url("./assets/fonts/GRILLEDCHEESEBTN.TTF") format("truetype-variations");
}

body {
  font-family: "Roboto", sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  color: white;
  background-color: $color-workspace;
  overflow: auto;
  box-sizing: border-box;
  font-size: 16px;
  line-height: 1.65;
  color: white;
}

.content {
  position: absolute;
  top: 0;
  left: 0;
  overflow: hidden;

  padding: 0;
  margin: 0;

  width: 100%;
  height: 100%;
  min-width: $content-min-width;
  min-height: $content-min-height;
}

//Set custom scrollbar
::-webkit-scrollbar {
  width: 5px;
  height: 5px;
}

::-webkit-scrollbar-track {
  background: transparent;
}

::-webkit-scrollbar-thumb {
  background: $color-gray-3-1;
  border-radius: 10px;
}

//Set custom moveable colors
.moveable-line {
  background: $color-yellow !important;
}

.moveable-control {
  background: $color-yellow !important;
  border-color: $color-yellow !important;
}
</style>
